import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BasicUser } from 'src/app/domain/models/User';
import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { InstructiveInfo, MasterLoad, Pallet, PalletInstructiveFormat, PalletPackingList } from 'src/app/domain/models/Pallet';

import { TransportTypeUtils } from 'src/app/ui/util/transportType.Utils';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthApiService } from 'src/app/application/service/AuthService';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { ProfileContactInfo, ProfilePackingListColumn } from 'src/app/domain/models/Profile';
import { ActivatedRoute, Router } from '@angular/router';
import { Routes } from 'src/app/infrastructure/routes';
import { Table } from 'primeng/table';
import { ImportOrderDetailGateway } from 'src/app/application/gateway/ImportOrderDetailGateway';
import { PdfUtils } from 'src/app/ui/util/pdf.utils';
import { DeliveryService } from 'src/app/application/service/DeliveryService';
import { excelUtils } from 'src/app/ui/util/excel-utils';
import { DefaultProfilePackingListColumnDefault, ProfilePackingListColumnLabels } from 'src/app/ui/util/packing-list-column-utils';

@Component({
  selector: 'app-packing-list-view',
  templateUrl: './packing-list-view.component.html',
  styleUrls: ['./packing-list-view.component.css'],

})
export class PackingListViewComponent {

  profile: ProfileContactInfo | undefined
  companyName: string = ""
  orders: LoadOrderListItem[] = []
  shipments: LoadOrderListItem[] = []
  searchTerm: string = '';

  masterLoads: MasterLoad[] = []

  loading: boolean = false
  loadingSummary: boolean = false
  year: number = new Date().getFullYear()

  filteredRegisters: PalletPackingList[] = []
  containerFilter: string[] = []
  weekFilter: number[] = []
  importerFilter: string[] = []
  specieFilter: string[] = []
  varietyFilter: string[] = []
  shipFilter: string[] = []


  importOrderDetailGuid: string = ""

  importOrderDetailArray: InstructiveInfo | undefined

  palletsList: PalletPackingList[]=[]
  palletsSummary: PalletInstructiveFormat[]=[]

  totalPallets: number = 0;
  totalBoxesPerPallets: number = 0;

  loadingBtnPacking: boolean = false
  loadingBtnProforma: boolean = false;
  loadingBtnIsf: boolean = false;

  profileUser: BasicUser | undefined

  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  isProgram: boolean = false

  withPackaging: boolean = true
  withLabel: boolean = true
  withSpeciesSize: boolean = true

  profilePackingListColumn: ProfilePackingListColumn = DefaultProfilePackingListColumnDefault;
  columnLabels: ProfilePackingListColumnLabels = ProfilePackingListColumnLabels;


  selectedColumns: string[] = []

  columnOptions: {label: string, value: string}[] = []

  selectAll: boolean = false;

  dataCards: {label: string, value: string}[] = []
  groupedDataCards: any[][] = []

  constructor(
    private _router: Router,
    private _messageService: MessageService,
    private _palletService: PalletGateway,
    private _authService: AuthGateway,
    private _profileService: ProfileService,
    private _importOrderDetailService: ImportOrderDetailGateway,
    private _activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private _deliveryService: DeliveryService
  ) {
    if (this._router.getCurrentNavigation()?.extras?.state?.['year'] !== undefined) {
      this.year = this._router.getCurrentNavigation()?.extras.state?.['year'];
    }
    this._activatedRoute.params.subscribe(params => {
      this.importOrderDetailGuid = params['importOrderDetailGuid']
    })
    this._activatedRoute.queryParams.subscribe(queryParams => {
      this.isProgram = queryParams['isProgram'] === 'true';
    })
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    if(this.isProgram){
      let breadcrumbMenuItemLabel1 = "Packing List View"
      let breadcrumbHomeMenuItemLabel = 'Reports'

      if(this.profileUser) {
        switch(this.profileUser.lang) {
          case 'en':
            breadcrumbMenuItemLabel1 = "Packing List View"
            breadcrumbHomeMenuItemLabel = 'Reports'
            break
          case 'es':
            breadcrumbMenuItemLabel1 = 'Vista Packing List'
            breadcrumbHomeMenuItemLabel = 'Reportes'
            break
        }
      }

      this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
      this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrdersProgram };

    }
    else{

      let breadcrumbMenuItemLabel1 = "Packing List View"
      let breadcrumbHomeMenuItemLabel = 'My loads'

      if(this.profileUser) {
        switch(this.profileUser.lang) {
          case 'en':
            breadcrumbMenuItemLabel1 = "Packing List View"
            breadcrumbHomeMenuItemLabel = 'My loads'
            break
          case 'es':
            breadcrumbMenuItemLabel1 = 'Vista Packing List'
            breadcrumbHomeMenuItemLabel = 'Mis cargas'
            break
        }
      }

      this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
      this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrders };

    }

    this.loadPackingList()
    this.companyName = this._authService.getUser()?.companyName ?? ""
    this._profileService.getContactInfo().subscribe({
      next: (v) => {
        this.profile =  v
        this.getProfilePackingListConfig()
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
      },
    })
  }

  onChangeAll() {
    if (this.selectedColumns.includes('all')) {
      this.columnOptions.forEach(x => this.selectedColumns.push(x.value))
    }
    else {
      this.selectedColumns = [];
    }

    this.updateProfilePackingList()
  }

  handleSelectCheck(event: any, value: string) {
    const selectedItems = event.checked;
    this.selectedColumns = selectedItems;

    if (value === 'all') {
      this.onChangeAll()
      return
    }

    // Si están seleccionados todos los elementos excepto "all", marcar "all" como seleccionado
    if ((selectedItems.length + 1 === this.columnOptions.length) && !selectedItems.includes('all')) {
      this.selectedColumns.push('all');
    }
    // Si no están seleccionados todos los elementos, desmarcar "all"
    if ((selectedItems.length !== this.columnOptions.length) && selectedItems.includes('all')) {
      this.selectedColumns = this.selectedColumns.filter(item => item !== 'all');
    }

    this.updateProfilePackingList();
  }

  filterLoads() {
    if (!this.searchTerm.trim()) {
      // Si el término de búsqueda está vacío, mostrar todos los pedidos
      this.filteredRegisters = this.palletsList;
    } else {
      // Filtrar los pedidos basados en el término de búsqueda
      this.filteredRegisters = this.palletsList.filter(product =>
        product.importOrderDetailId.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.palletNumber.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportSpecies?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportVariety?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.producer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.speciesSize?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportHarvestDate?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportQualityControlDate?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportPackaging?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportPalletType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportTag?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportBagType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportBoxSize?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportNetWeight?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportFridgeStorage?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportBoxesPerPallet?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportMark?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportContainerNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportGrade?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportTemptale?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportOriginCountry?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportCertificate1?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportCertificate2?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportCertificate3?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.excelImportLoadWeek?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.importOrderDetail?.exportOffer?.exporter?.companyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.importOrderDetail?.exportOffer?.exporter?.contactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.importOrderDetail?.importOrder?.importer?.companyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.importOrderDetail?.importOrder?.importer?.contactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    }
  }

  loadPackingList(){
    this.loading = true;
    this.loadingSummary = true;
    this._importOrderDetailService.getInstructiveInfo(this.importOrderDetailGuid, this.withLabel, this.withPackaging, this.withSpeciesSize).subscribe({
      next: (v) => {
        this.loading = false;
        this.loadingSummary = false;
        this.importOrderDetailArray = v
        this.palletsList = v?.pallets
        this.filteredRegisters = v?.pallets
        this.palletsSummary = v?.palletSummary
        this.totalPallets = v.totalPallets ?? 0
        this.totalBoxesPerPallets = v.totalBoxes ?? 0
        this.getCards(v)
      },
      error: (e) => {
        this.loading = false
        this.loadingSummary = false
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: 'Acción fallida',
          detail: 'No se pudieron recuperar los detalles de la orden de importación.' });
      },
    })
  }

  getCards(data: InstructiveInfo) {
    if (data !== undefined) {

      this.translate.get([
        'UserPages.PackingListView.MiniTables.Exporter',
        'UserPages.PackingListView.MiniTables.ContainerNumber',
        'UserPages.PackingListView.MiniTables.Instructions',
        'UserPages.PackingListView.MiniTables.Departure',
        'UserPages.PackingListView.MiniTables.Phone',
        'UserPages.PackingListView.MiniTables.Mail',
        'UserPages.PackingListView.MiniTables.Address',
        'UserPages.PackingListView.MiniTables.Contact',
        'UserPages.PackingListView.MiniTables.Destination',
        'UserPages.PackingListView.MiniTables.Type',
        'UserPages.PackingListView.MiniTables.DestinationCountry',
        'UserPages.PackingListView.MiniTables.ETD',
        'UserPages.PackingListView.MiniTables.Receiver',
        'UserPages.PackingListView.MiniTables.CarrierName',
        'UserPages.PackingListView.MiniTables.Vessel',
        'UserPages.PackingListView.MiniTables.ETA',
      ]).subscribe({
        next: (tranlations) => {
          this.dataCards = [
            // 1 card
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Exporter'],
              value: data.exporterCompanyName!
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.ContainerNumber'],
              value: data.containerNumber ?? 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Instructions'],
              value: data.packingNumber ?? 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Departure'],
              value: (data.departureCountryName && data.departurePortName) ? data.departurePortName : 'No data'
            },
            // 2 card
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Phone'],
              value: data.exporterContactPhone!
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Mail'],
              value: data.exporterContactEmail!
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Address'],
              value: data.exporterContactAddress!
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Contact'],
              value: data.exporterCompanyName!
            },
            // 3 card
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Destination'],
              value: data.destinationPortName != null ? data.destinationPortName : data.destinationCityName ?? 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Type'],
              value: data.transportType != null ? this.getTransportTypeName(data?.transportType ?? 0) : ''
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.DestinationCountry'],
              value: data.destinationCountryName ?? 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.ETD'],
              value: data.etd ?? 'No data'
            },
            // 4 card
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Receiver'],
              value: data.receiverPackingList ?? 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.CarrierName'],
              value: data.shippingCompanyName ? data.shippingCompanyName : data.carrierName ? data.carrierName : 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.Vessel'],
              value: data.ship ?? 'No data'
            },
            {
              label: tranlations['UserPages.PackingListView.MiniTables.ETA'],
              value: data.eta ?? 'No data'
            }
          ]

          this.groupedDataCards = [];
          for (let i = 0; i < this.dataCards.length; i += 4) {
            this.groupedDataCards.push(this.dataCards.slice(i, i + 4))
          }
        }
      });
    }
  }

  goToLoadsPage(): void {
    this.clearFilters()
    this._router.navigate([Routes.userLoadOrders]);
  }

  clearFilters() {
    sessionStorage.removeItem("dt-masterload-session")
  }

  getTransportTypeName(transportType: number): string{
    return TransportTypeUtils.getTransportName(this.profile?.lang ?? 'en', transportType);
  }

  downloadPackingListApi(importOrderDetailGuid: string){
    this.loadingBtnPacking = true;
    this._importOrderDetailService.getDownloadPackingListSwitch(importOrderDetailGuid, this.withLabel, this.withPackaging, this.withSpeciesSize).subscribe(
      {
        next: (resultBlob: any) => {

          const contentDisposition = resultBlob.headers.get('content-disposition');
          let nombreArchivo = 'Packing_List';
          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);
            if (match && match[1]) {
                nombreArchivo += match[1];
            }
            PdfUtils.downloadPdf(resultBlob.body, nombreArchivo);
            }else{
              PdfUtils.downloadPdf(resultBlob.body, nombreArchivo);
            }
            this.loadingBtnPacking = false;
          },
          error: (e) => {
            this.loadingBtnPacking = false;
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail:  this.translate.instant('UserPages.PackingListView.ErrorDownloadPDF') })
          },
          complete: () => {
            this.loadingBtnPacking = false;
          }
      })
  }

  downloadPackingListExcel(importOrderDetailGuid: string){
    this.loadingBtnPacking = true;
    this._deliveryService.downloadPackingList(importOrderDetailGuid, this.withLabel, this.withPackaging, this.withSpeciesSize).subscribe(
      {
        next: (resultBlob: any) => {

          const contentDisposition = resultBlob.headers.get('content-disposition');
          let nombreArchivo = 'Packing_List';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);
            if (match && match[1]) {
                nombreArchivo += match[1];
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }else{
          excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }

          this.loadingBtnPacking = false;
          },
          error: (e) => {
            this.loadingBtnPacking = false;
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail:  this.translate.instant('UserPages.PackingListView.ErrorDownloadPDF') })
          },
          complete: () => {
            this.loadingBtnPacking = false;
          }
      })
  }

  downloadIsf()
  {
    this.loadingBtnIsf = true;
    this._deliveryService.downloadIsf(this.importOrderDetailGuid).subscribe(
      {
        next: (resultBlob: any) => {

          const contentDisposition = resultBlob.headers.get('content-disposition');
          let nombreArchivo = 'ISF';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);
            if (match && match[1]) {
                nombreArchivo = match[1];
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }else{
          excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }

          this.loadingBtnIsf = false;
          },
          error: (e) => {
            this.loadingBtnIsf = false;
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail:  this.translate.instant('UserPages.PackingListView.ErrorDownloadPDF') })
          },
          complete: () => {
            this.loadingBtnIsf = false;
          }
      })
  }

  updateProfilePackingList()
  {
    this.loading = true;
    this.buildProfilePackingList()
    this._profileService.updateProfilePackingListColumn(this.profilePackingListColumn).subscribe({
      next: (v) => {
          this.loading = false;
          this.loadPackingList()
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail:  this.translate.instant('UserPages.PackingListView.ErrorDownloadPDF') })
      }
    })
  }

  buildProfilePackingList()
  {
    for (const key in this.profilePackingListColumn) {
      if(!this.selectedColumns.includes(key) && this.columnLabels[key] )
      {
        this.profilePackingListColumn[key as keyof ProfilePackingListColumn] = false;
      }else if(this.columnLabels[key])
      {
        this.profilePackingListColumn[key as keyof ProfilePackingListColumn] = true
      }
    }

    this.profilePackingListColumn.withLabel = this.withLabel;
    this.profilePackingListColumn.withPackaging = this.withPackaging;
    this.profilePackingListColumn.withSpeciesSize = this.withSpeciesSize;
  }

  getProfilePackingListConfig()
  {
    this.loading = true;
    this._profileService.getProfilePackingListColumn().subscribe({
      next: (v) => {
        this.loading = false;
        this.profilePackingListColumn = {...v}
        this.withLabel = this.profilePackingListColumn.withLabel ?? false;
        this.withPackaging = this.profilePackingListColumn.withPackaging ?? false;
        this.withSpeciesSize = this.profilePackingListColumn.withSpeciesSize ?? false;
        this.buildOptions()
        this.loadPackingList()
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail:  this.translate.instant('UserPages.PackingListView.ErrorGetProfilePackingList') })
      }
    })
  }

  buildOptions()
  {
    this.columnOptions = []
    this.selectedColumns = []
    this.columnOptions.push({ label: this.profile?.lang == 'es' ? 'Todos' : 'All', value: 'all' })

    Object.keys(this.profilePackingListColumn).map( key =>
    {
      if(this.columnLabels[key])
      {
        this.columnOptions.push(
        {
          label: this.profile?.lang == 'es' ? this.columnLabels[key].nameEs : this.columnLabels[key].name,
          value: key
        })
      }
    })

    Object.entries(this.profilePackingListColumn).map(([key, value]) => {

      if(this.columnLabels[key])
      {
        if(value)
          {
            this.selectedColumns.push(key)
          }
      }
    })

    if(this.selectedColumns.length + 1 == this.columnOptions.length)
    {
      this.selectedColumns.push('all')
      this.selectAll = true;
    }else{
      this.selectAll = false;
    }
  }

  downloadProformaExcel()
  {
    if(this.importOrderDetailGuid)
      {
      this.loadingBtnProforma = true;
      this._palletService.downloadProformaExcel(this.importOrderDetailGuid).subscribe({
        next: (resultBlob) => {
            const contentDisposition = resultBlob.headers.get('content-disposition');
            let nombreArchivo = 'proforma_invoice';

            if (contentDisposition) {
              const match = contentDisposition.match(/filename=([^]+);/);
              if (match && match[1]) {
                  nombreArchivo += match[1];
              }

              excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
          }else{
            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
          }

          this.loadingBtnProforma = false;
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail:  this.translate.instant('UserPages.PackingListView.ErrorDownloadPDF') })
          this.loadingBtnProforma = false;
        }
      })
    }


  }
}
